import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { NativeDatePicker, Text } from "components/base/Form";
import { Alert } from "components/base/Toast";
import moment from "moment";
import { useState } from "react";
import { DELETE_OBJECTIVE, SAVE_OBJECTIVE } from "./graphql";

const ObjectiveForm = ({ originalObjective, teamId, hide }) => {
  const [description, setDescription] = useState(
    originalObjective?.description,
  );
  const [notes, setNotes] = useState(originalObjective?.notes);
  const [dueDate, setDueDate] = useState(
    originalObjective?.dueDate || moment().format("YYYY-MM-DD"),
  );

  let variables = {
    description,
    notes,
    dueDate: moment(dueDate).format("YYYY-MM-DD"),
  };
  if (originalObjective) variables.id = originalObjective.id;
  if (teamId) variables.teamId = teamId;

  const [save, saveRes] = useMutation(SAVE_OBJECTIVE, {
    variables,
    onCompleted() {
      Alert("success", "Objective saved successfully");
      hide();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_TEAMS_FOR_OBJECTIVES"],
    awaitRefetchQueries: true,
  });

  const [deleteObjective, deleteObjectiveRes] = useMutation(DELETE_OBJECTIVE, {
    onCompleted() {
      hide();
      Alert("success", "Objective deleted successfully");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_TEAMS_FOR_OBJECTIVES"],
    awaitRefetchQueries: true,
  });

  function deleteHandler() {
    if (window.confirm("Are you sure you want to delete this objective?")) {
      deleteObjective({ variables: { id: originalObjective.id } });
    }
  }

  return (
    <div>
      <div className=" space-y-3">
        <div>
          <div>Description:</div>
          <Text
            className="mt-1"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div>
          <div>Main Challenge:</div>
          <Text
            className="mt-1"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>

        <div className="flex items-center space-x-3">
          <div>Due Date:</div>
          <NativeDatePicker
            value={dueDate}
            onChange={(e) =>
              setDueDate(moment(e.target.value).format("YYYY-MM-DD"))
            }
          />
        </div>
      </div>

      <div className="text-sm mt-6 flex justify-between">
        <Button primary onClick={save} loading={saveRes.loading}>
          Save
        </Button>
        {originalObjective && (
          <Button
            danger
            onClick={deleteHandler}
            loading={deleteObjectiveRes.loading}
          >
            Delete Objective
          </Button>
        )}
      </div>
    </div>
  );
};

export default ObjectiveForm;
